// extracted by mini-css-extract-plugin
export default {"header":"Header_header__lw102","cdsLogo":"Header_cdsLogo__RmxZC","logo":"Header_logo__mRk+E","navLinks":"Header_navLinks__7hKuy","ctaButton":"Header_ctaButton__OkVi6"};